import styled from 'styled-components';

import { Text } from '@/nova/components';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { SPACE } from '../../../../../../theme/tokens';
import { CARD_BRAND, SPEI } from '../../spei.tokens';

/*
 * The Pix screen shares its whole frame with the SPEI one (scroll column, amount headline,
 * notice, steps, footer), so those pieces are re-exported rather than re-declared: the two rails
 * can never drift apart visually. Only the QR and the mobile fold are new here.
 */
export {
  Root,
  Scroll,
  LogoRow,
  Title,
  Lead,
  AmountBlock,
  AmountLabels,
  AmountLabel,
  AmountValue,
  Panel,
  Notice,
  NoticeIcon,
  NoticeText,
  Expiry,
  StepsTitle,
  StepsList,
  StepRow,
  StepIndex,
  StepText,
  Footer,
  ContinueButton,
  ContinueLabel,
} from './SpeiInstructions.styles';

/* Centres the QR plate in the column. */
export const QrBlock = styled.div`
  margin-top: ${SPACE[16]};
  display: flex;
  justify-content: center;
`;

/* A QR must be dark-on-light to scan in every banking app, so it always sits on the white
   card-brand plate, whatever the studio theme. */
export const QrPlate = styled.div`
  display: inline-flex;
  border-radius: 12px;
  background: ${CARD_BRAND.plate};
  padding: ${SPACE[12]};
  line-height: 0;
`;

/* The mobile fold holding the QR for a buyer paying from a second device. */
export const Disclosure = styled.details`
  margin-top: ${SPACE[16]};
  border-radius: 12px;
  border: 1px solid ${SPEI.panelBorder};
  background: ${SPEI.panelBg};
  padding: ${SPACE[12]} ${SPACE[16]};

  &[open] > summary {
    margin-bottom: ${SPACE[4]};
  }
`;

export const DisclosureSummary = styled.summary`
  cursor: pointer;
  font-size: 14px;
  line-height: 1.4;
  color: ${CFG.foreground};
`;

export const DisclosureLabel = styled(Text)`
  display: inline;
`;
